module.exports = __webpack_public_path__ + "static/media/golf-carousel-640x360.597178b1.jpg";